import React from 'react'
import {Link} from 'react-router-dom'
import PrimeCard from './PrimeCard'
import PogopassCard from './PagopassCard'
import '../deal.css';
import {Container} from 'react-bootstrap';

function Blognav() {
  return (
      <>
      <Container>
        <div className="myrow" >
        <Link to="/">Home </Link> {'>'} Blog
          <div className="content">
              <div className="leftcolumn">

                <div className="dealsdata" >
                 <PrimeCard/>
                  <PogopassCard/>
                </div>
                 <div className="loadmore"  >
                </div>
              </div>

            <div className="rightcolumn"></div>
          </div>
        </div>
      </Container>
    </>
  )
}

export default Blognav